import { forwardRef, ReactNode } from 'react';

import Form, { Item } from 'devextreme-react/form';

import ModalFooter from 'components/appModalFooter';
import { Popup, ValidationGroup } from 'devextreme-react';

import styles from './ModalForm.module.css';

type Props = {
  visible: boolean;
  isLoadingSubmit?: boolean;
  disabledSubmit?: boolean;
  typeConfirm?: 'danger' | 'default' | 'normal' | 'success' | undefined;
  onShowing?: () => void;
  onHidden: () => void;
  onSubmit: (e?: any) => void;
  children?: ReactNode;
  title: string;
  textConfirm: string;
  hideConfirm?: boolean;
} & Popup['props'];

export const ModalForm = forwardRef<ValidationGroup, Props>(
  (
    {
      onHidden,
      onShowing,
      onSubmit,
      visible,
      isLoadingSubmit,
      disabledSubmit,
      title,
      children,
      hideConfirm,
      textConfirm,
      typeConfirm = 'default',
      ...props
    },
    ref,
  ) => {
    return (
      <Popup
        visible={visible}
        dragEnabled={true}
        hideOnOutsideClick
        showTitle={true}
        title={title}
        onShowing={onShowing}
        onHidden={onHidden}
        height="auto"
        {...props}
      >
        <div className={styles.root}>
          <div className={styles.content}>
            <form onSubmit={onSubmit}>
              <ValidationGroup ref={ref}>
                <Form className={styles.form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    {children}
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={onSubmit}
                  hideModal={onHidden}
                  disabledSubmit={isLoadingSubmit || disabledSubmit}
                  textConfirm={textConfirm}
                  typeConfirm={typeConfirm}
                  hideConfirm={hideConfirm}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    );
  },
);
